module.exports = __webpack_public_path__ + "static/media/Host Asset 11.dbad22b6.svg";